import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoValidateDirective } from '../../directives/auto-validate.directive';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-daterange',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DatePickerModule, AutoValidateDirective],
  template: `
    <p-datepicker
      [formControl]="formControl"
      selectionMode="range"
      [iconDisplay]="'input'"
      [showIcon]="true"
      appendTo="body"
      [class]="config.controlClass || 'w-full'"
      [placeholder]="config.placeholder || 'Select date range'"
      fluid
      appAutoValidate />
  `
})
export class DaterangeFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
